export default "/assets/images/mila-feed-09-thumbnail.0e1e7d1152c57487.jpg";